export function tooltipEvents(context) {
    $(".js-show-tooltip", context).tooltip();
    $(".js-toast", context).toast("show");
    $('[data-toggle="popover"]', context).each(function () {
        const $el = $(this);
        const theme = ($el.data('popover-theme') || $el.data('popoverTheme') || $el.data('theme') || '').toString().toLowerCase();
        const border = $el.data('popover-border') || $el.data('popoverBorder') || false;
        const options = { trigger: 'hover', html: true, container: 'body' };
        const classes = ['popover'];
        if (border) {
            classes.push('popover-bordered');
        }
        if (theme === 'dark' || theme === 'dark-soft' || theme === 'muted' || theme === 'soft') {
            classes.push('popover-dark-soft');
        }
        if (classes.length > 1) {
            options.template = `<div class="${classes.join(' ')}" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>`;
        }
        $el.popover(options);
    });

    $(document).on('mouseenter', '.js-show-popover-hover', function () {
        const $el = $(this);
        if (!$el.data('bs.popover')) {
            $el.popover({ trigger: 'hover', html: true, container: 'body' }).popover('show');
        } else {
            $el.popover('show');
        }
    });
    $(document).on('mouseleave', '.js-show-popover-hover', function () {
        $(this).popover('hide');
    });
}
